const BRIDGE_FLAG = 'intakeBridge';

// One-shot marker: the BASIC_INFO -> first-step bridge fires only after a BasicInfo submit.
export const markIntakeBridge = () => sessionStorage.setItem(BRIDGE_FLAG, '1');

export const consumeIntakeBridge = () => {
  const marked = sessionStorage.getItem(BRIDGE_FLAG) !== null;
  sessionStorage.removeItem(BRIDGE_FLAG);
  return marked;
};
